export function getNavbarHeight() {
  const navbarHeight = document.documentElement.style.getPropertyValue(
    '--icf-navbar-height'
  )
  return navbarHeight ? Number.parseInt(navbarHeight) : 0
}
